import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import NavbarComponent from './NavbarComponent';
import { useLanguage } from './LanguageContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import backgroundImage from './images/Studio-6.jpg';
import MainPageContent from './MainContent/MainPageContent';
import Label from './Label'; // Import the new Label page

const App = () => {
    const { translations } = useLanguage();

    return (
        <Router>
            <NavbarComponent />
            <Routes>
                {/* Home page */}
                <Route path="/" element={
                    <div
                        style={{
                            backgroundImage: `url(${backgroundImage})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            minHeight: '100vh',
                            color: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <MainPageContent />
                    </div>
                } />

                {/* Label Page */}
                <Route path="/label" element={<Label />} />
            </Routes>
        </Router>
    );
};

export default App;